/* eslint-disable prefer-destructuring */
import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';
import memoize from 'lodash.memoize';

const getTransactions = (state) => resolveProp('entities.transactions.byId', state) || {};

export default createSelector(getTransactions, (transactions) =>
    memoize((transactionsId) => transactions[transactionsId]),
);
